module.exports = __webpack_public_path__ + "static/media/berylGeometric.5fdf7d1e.png";